import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ChangeEventHandler, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import ImageIcon from './ImageIcon';

interface Props {
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

function FileUploader({ onChange }:Props) {
    const inputRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation('common');
    return (
        <Container onClick={() => inputRef.current?.click()} >
            <Text color={colors.gray5}>
                {t('fileUploader.fileLimit')}
            </Text>
            <ImageIcon/>
            <input type='file' hidden
                onChange={onChange}
                ref={inputRef} />
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    background-color: var(--color-gray1);
    border: 1px solid var(--color-gray4);
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    width: 100%;
`;

export default FileUploader;
